<section class="section-white" *ngIf="apiData" id="downloadForm">
  <div class="section-container-inside">
    <div class="whitepaper-container">
      <div class="whitepaper-content">
        <div class="csa_card mb-4 mb-md-5" *ngIf="!apiData?.psCustomerStoryPdf">
          <div class="card_header">
            <img
              src="{{ apiData?.logo?.url }}"
              alt="{{ apiData?.logo?.title }}"
            />
          </div>
          <div class="card_body position-relative">
            <h4 class="h6 mb-3">{{ apiData?.productsUsed?.header }}</h4>
            <ul class="list_icon pt-2 pb-4 p-md">
              <li *ngFor="let bullet of apiData?.productsUsed?.bullets">
                <i class="ic_icon">
                  <img
                    src="{{ bullet?.fields?.images?.[0]?.fields?.file?.url }}"
                /></i>
                {{ bullet?.fields?.title }}
              </li>
            </ul>

            <span class="cs_bd_full mb-5"></span>
            <ul class="list-unstyled dt_list pt-4 mt-4">
              <li
                class="d-flex align-items-center mb-4"
                *ngFor="let bullet of apiData?.categoryTags"
              >
                <span class="icon_c_set">
                  <img
                    src="{{ bullet?.fields?.images?.[0]?.fields?.file?.url }}"
                    alt="{{ bullet?.fields?.images?.[0]?.fields?.title }}"
                  />
                </span>
                <span>
                  <span class="d-inline-block">{{ bullet?.fields?.title }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="section-description align-l mar-b-48"
          [innerHtml]="apiData?.caseStudyLeftContent | toHtml"
          *ngIf="apiData?.caseStudyLeftContent"
        ></div>
      </div>
      <div class="whitepaper-form-container cus-story-content-right">
        <div
          class="wys p-md"
          [innerHtml]="apiData?.articleContent | toHtml"
          *ngIf="!apiData?.psCustomerStoryPdf"
        ></div>
        <div
          id="hubspotformCustomerStory"
          class="w-100"
          *ngIf="apiData?.psCustomerStoryPdf"
        ></div>
      </div>
    </div>
  </div>
</section>
